// extracted by mini-css-extract-plugin
export var collapsedSummary = "_pu-0";